import React from 'react';
import { string } from 'prop-types';

import { Container } from './DataLabel.styled';

const DataLabel = ({ align, id, label, children }) => {
  const dataId = `${id}-label`;
  return (
    <Container align={align}>
      <label htmlFor={dataId}>{label}</label>
      <span id={dataId}>{children}</span>
    </Container>
  );
};

DataLabel.propTypes = {
  align: string
};

DataLabel.defaultProps = {
  align: 'left'
};

export default DataLabel;
